import { LogoMark } from '@/shared/components/ui/logo'
import type { ReactNode } from 'react'

interface IrisShellProps {
  children: ReactNode
}

export function IrisShell({ children }: IrisShellProps) {
  return (
    <div className="min-h-dvh bg-[var(--bg)] pb-[env(safe-area-inset-bottom)]">
      <div className="mx-auto max-w-lg px-5 pb-12 pt-8">
        <div className="panel-arrive mb-8 flex flex-col items-center gap-3">
          <LogoMark size={20} className="opacity-40" />
          <p className="clara-small text-center tracking-[0.08em] text-[var(--ink-3)]">
            Evidence submission, made simple
          </p>
        </div>
        {children}
      </div>
    </div>
  )
}
